import React from "react";
import { Empty } from "antd";
import { ReactComponent as NoResultsIcon } from '../../../../assets/icons/no_results_icon.svg';


const NoResults = (props) =>{
    return(
        <Empty
              id='no-results-image'
              image={<NoResultsIcon/>}
              description={
                <>
                  <p className="no-results-p">
                    {props.description}
                  </p>
                  <span className="no-results-span">
                    {props.subDescription}
                  </span>
                </>
              }
            ></Empty>
    )
}

export default NoResults;